<!--
    描述：项目相关树信息
    时间：2020-05-25
    Created by 张卫华
-->
<template>
    <div class="h100">
        <div class="w-table-layout">
            <div class="w-table-content"
                 ref="tableContent">
                <el-table :data="treeTableData.tableData"
                          row-key="id"
                          v-loading="treeTableData.loading"
                          ref="menusTree"
                          default-expand-all
                          :height="treeTableData.tableH"
                          border
                          highlight-current-row
                          @row-click="rowClick"
                          :tree-props="{children: 'children'}">
                    <el-table-column prop="sname" label="项目名称" header-align="center" align="left" show-overflow-tooltip min-width="140"></el-table-column>
                    <el-table-column prop="menuType" label="单项工程名称" header-align="center" align="left" show-overflow-tooltip min-width="130"></el-table-column>
                    <el-table-column prop="menuType" label="单位工程名称" header-align="center" align="left" show-overflow-tooltip min-width="130">
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    export default {
        components: {},
        props : {},
        data() {
            return {
                treeTableData: {
                    loading: false,
                    tableH: 200,
                    tableData: []
                }
            }
        },
        computed: {
            ...mapState('app', { clientSize: state => state.clientSize }),
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.treeTableData.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        // 进入缓存页面触发
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.treeTableData.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        watch: {
            clientSize(val) {
                setTimeout(() => {
                    this.treeTableData.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            }
        },
        created() {},
        methods: {
            rowClick(){

            },
        }
    }
</script>

<style scoped>

</style>